export default __webpack_public_path__ + "static/media/mari.620ada8b.jpg";